import { px } from '@adsk/alloy-react-helpers';

import {
  AlloyLegacyThemeDesignTokens,
  LoadMoreDataDesignTokens,
} from '../types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = NonNullable<WeaveTheme['tokens']>;

export const getLoadMoreDataTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): LoadMoreDataDesignTokens => ({
  error: {
    'margin-right': px(theme.spacing.XS),
    'font-family': theme.typography.bodySmall.fontFamily,
    'font-size': theme.typography.bodySmall.fontSize,
    'font-weight': String(theme.typography.bodySmall.fontWeight),
    'line-height': theme.typography.bodySmall.lineHeight,
  },
});

export const getLoadMoreDataTokensWeave = (
  tokens: WeaveTokens,
  fontFamily: string,
): LoadMoreDataDesignTokens => ({
  error: {
    'margin-right': tokens?.generic?.spacing?.[8],
    'font-family': fontFamily,
    'font-size': tokens?.generic?.['font-size']?.[12],
    'font-weight': tokens?.generic?.['font-weight']?.medium,
    'line-height': tokens?.generic?.['line-height']?.[16],
    color: tokens?.semantic?.['text-color']?.medium.default,
  },
});
